'use client';

interface ScrollToElementOptions {
  /** Переопределяет высоту хедера */
  headerHeight?: number;
  /** Дополнительный отступ сверху */
  offset?: number;
}

/** Плавно прокручивает к элементу с учетом хедера и отступа */
export const utilScrollToElement = (
  element: HTMLElement | null,
  options?: ScrollToElementOptions
) => {
  if (!element) return;

  const computedHeaderHeight =
    parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--head-fixed-height'
      )
    ) || 64;

  const headerHeight = options?.headerHeight ?? computedHeaderHeight;
  const extraOffset = options?.offset ?? 0;

  const elementPosition = element.getBoundingClientRect().top;
  const targetPosition =
    elementPosition + window.pageYOffset - headerHeight - extraOffset;

  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
};
